import React from "react";
import "./styles.css";
import { Link, useLocation } from "react-router-dom";
import Button from "../CtaButton";
import { useTranslation } from "react-i18next";

const IndustriesSection = () => {
  const location = useLocation();

  const { t } = useTranslation("industries");
  const industriesContent = t("newIndustriesSection", { returnObjects: true });

  console.log("location", location.pathname);

  return (
    <section className="industries-section">
      <div className="container position-relative">
        <div className="row align-items-center gy-5">
          <div className="col-lg-5 industries-section-content-box">
            <h2 className="display-5 fw-bold mb-3">
              {industriesContent?.heading}
            </h2>
            <p className="common-text mb-4">{industriesContent?.description}</p>

            {location.pathname === "/Industries" ? (
              <></>
            ) : (
              <Button
                text={industriesContent?.buttonText}
                link={industriesContent?.buttonLink}
              />
            )}
          </div>

          <div className="col-lg-7">
            <div className="row d-none d-md-flex">
              <div className="industry-card-wrapper col-4">
                {industriesContent?.cards.slice(0, 3).map((c, i) => (
                  <Link
                    key={i}
                    to={`/industries/${c.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={`industry-card ${c.cls}`}>
                      <div className="industry-icon">
                        <img
                          style={{ filter: "invert(1)" }}
                          src={c.icon}
                          alt={c.title}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className="industry-title">{c.title}</div>
                    </div>
                  </Link>
                ))}
              </div>

              <div
                className="industry-card-wrapper col-4"
                style={{ marginTop: "4rem" }}
              >
                {industriesContent?.cards.slice(3, 6).map((c, i) => (
                  <Link
                    key={i}
                    to={`/industries/${c.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={`industry-card ${c.cls}`}>
                      <div className="industry-icon">
                        <img
                          style={{ filter: "invert(1)" }}
                          src={c.icon}
                          alt={c.title}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className="industry-title">{c.title}</div>
                    </div>
                  </Link>
                ))}
              </div>

              <div
                className="industry-card-wrapper col-4"
                style={{ marginTop: "2rem" }}
              >
                {industriesContent?.cards.slice(6, 9).map((c, i) => (
                  <Link
                    key={i}
                    to={`/industries/${c.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={`industry-card ${c.cls}`}>
                      <div className="industry-icon">
                        <img
                          style={{ filter: "invert(1)" }}
                          src={c.icon}
                          alt={c.title}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className="industry-title">{c.title}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            {/* Mobile layout */}
            <div className="row d-md-none">
              <div className="industry-card-wrapper col-6 col-md-6">
                {industriesContent?.cards.slice(0, 4).map((c, i) => (
                  <Link
                    key={i}
                    to={`/industries/${c.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={`industry-card ${c.cls}`}>
                      <div className="industry-icon">
                        <img
                          style={{ filter: "invert(1)" }}
                          src={c.icon}
                          alt={c.title}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className="industry-title">{c.title}</div>
                    </div>
                  </Link>
                ))}
              </div>
              <div
                className="industry-card-wrapper col-6 col-md-6 industries-card-second-row"              >
                {industriesContent?.cards.slice(4).map((c, i) => (
                  <Link
                    key={i}
                    to={`/industries/${c.slug}`}
                    style={{ textDecoration: "none" }}
                  >
                    <div className={`industry-card ${c.cls}`}>
                      <div className="industry-icon">
                        <img
                          style={{ filter: "invert(1)" }}
                          src={c.icon}
                          alt={c.title}
                          width={30}
                          height={30}
                        />
                      </div>
                      <div className="industry-title">{c.title}</div>
                    </div>
                  </Link>
                ))}
              </div>
            </div>

            <img
              src="/images/life-at-bitsclan/mouse.svg"
              alt="CEO Image"
              style={{
                position: "absolute",
                bottom: "1rem",
                insetInlineEnd: "2rem",
                zIndex: "revert",
                width: "43%",
                opacity: 0.7,
              }}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
